import { useEffect, useState } from "react"
import { useParams } from "../../../Providers/ParamsProvider"
import { useUser } from "../../../Providers/UserProvider"
import LoadingSpinner from "../../Components/LoadingSpinner"
import { FaRegEdit } from 'react-icons/fa'
import { formatPhoneNumber } from '../../../Helpers/CustomConverter.jsx';
import { IoMdAddCircleOutline } from "react-icons/io"
import { OverlayTrigger, Popover } from "react-bootstrap"
import { RxCross2 } from "react-icons/rx"
import { toast } from "react-toastify"
import YesNoMessageModal from "../../Components/Modals/YesNoMessageModal"
import AddEditUserWithoutEHandelAccessModal from "./Components/AddEditUserWithoutEHandelAccessModal"
import { FaCheck } from "react-icons/fa6"
import { reverseDate } from "../../../Helpers/ValidatorHelper"
import SelectUserRolesModal from "./Components/SelectUserRolesModal"
import { useAuth } from "../../../Providers/AuthProvider"
import { MdNoteAdd } from "react-icons/md"
import YesNoCancelMessageModal from "../../Components/Modals/YesNoCancelMessageModal"
import AddEditCrmTaskModal from "../../Components/Modals/AddEditCrmTaskModal"
import useCommonFunctions from "../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions"

const CustomersWithoutEHandelAccess = () => {
    const { authState } = useAuth()
    const { handleGetCustomerUsersWithoutEHandelAccess, handleDeleteUserWithoutEHandelAcces, addCustomerUser } = useUser()
    const { isMobile } = useParams()
    const [users, setUsers] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [deleteObj, setDeleteObj] = useState({ show: false, recNo: -1, recNo: -1, custId: -1, contactNumber: '', userCode: '', userName: '', userLogin: '' })
    const [addEditObj, setAddEditObj] = useState({ show: false, user: null })
    const [showSelectUserRolesModal, setShowSelectUserRolesModal] = useState()
    const [userToAddAccesstoEhandel, setUserToAddAccesstoEhandel] = useState(null)
    const [showCrmPickTypeModal, setShowCrmPickTypeModal] = useState(false)
    const [crmModalObj, setCrmModalObj] = useState({ show: false, type: '', userName: '' })
    const [showOnlyUsersWithoutEHandelAccess, setShowOnlyUsersWithoutEHandelAccess] = useState(false)

    useEffect(() => {
        handleDownloadUsers()
    }, [])

    const handleDownloadUsers = async () => {
        setIsLoading(true)
        let data = await handleGetCustomerUsersWithoutEHandelAccess()
        setUsers(data)
        setIsLoading(false)
    }

    const handleDeleteClick = (recNo, userName, custId, contactNumber, userCode, userLogin) => {
        if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 4) {
            toast.warning('Brak uprawnień!')
            return
        }
        setDeleteObj({ show: true, recNo: recNo, userName: userName, custId: custId, contactNumber: contactNumber, userCode: userCode, userLogin: userLogin })
    }

    const handleDeleteUserModalAnswer = async (answer) => {
        if (answer) {
            await handleDeleteUser(deleteObj.recNo, deleteObj.custId, deleteObj.contactNumber, deleteObj.userCode, deleteObj.userLogin)
        }
        setDeleteObj({ show: false, recNo: -1, custId: -1, contactNumber: '', userCode: '', userName: '', userLogin: '' })
    }

    const handleDeleteUser = async (recNo, custId, contactNumber, userCode, userLogin) => {
        setIsLoading(true)
        let res = await handleDeleteUserWithoutEHandelAcces(recNo, custId, contactNumber, userCode, userLogin)
        if (res) {
            await handleDownloadUsers()
        }
        else {
            toast.error('Błąd w trakcie usuwania kontaktu!')
        }
        setIsLoading(false)
    }

    const handleAddEhandelUser = async (roles) => {
        if (roles) {
            let userObj = {
                userId: '',
                userLogin: userToAddAccesstoEhandel.email,
                phoneNumber: userToAddAccesstoEhandel.phoneNumber,
                firstName: userToAddAccesstoEhandel.name,
                lastName: userToAddAccesstoEhandel.surname,
                custId: userToAddAccesstoEhandel.custId,
                password: null,
                roles: roles
            }
            let res = await addCustomerUser(userObj)
            if (res === 204) {
                toast.success(`Przyznano dostęp do eHandlu`)
                toast.success(`Na podany adres email zostanie wysłana instrukcja aktywacji konta`)
                await handleDownloadUsers()
            }
            else {
                toast.error(`Błąd w trakcie przyznawania dostępnu do eHandlu: ${res}`)
            }
        }
        setShowSelectUserRolesModal(false)
        setUserToAddAccesstoEhandel(null)
    }

    const handleCrmTypeModalAnswer = (answer) => {
        let crmType = 'Cancel'
        switch (answer) {
            case 'Yes':
                crmType = 'Telefon'
                break
            case 'No':
                crmType = 'Wizyta'
                break
            case 'Cancel':
                crmType = 'Dowolne zdarzenie CRM'
                break
            default:
                crmType = 'Cancel'
        }
        if (crmType != 'Cancel') {
            setCrmModalObj(prev => ({
                ...prev,
                show: true,
                type: crmType
            }))
        }
        setShowCrmPickTypeModal(false)
    }

    return (<>
        <YesNoMessageModal
            show={deleteObj.show}
            onHide={handleDeleteUserModalAnswer}
            title={'UWAGA'}
            message={`Czy chcesz usunąć kontakt: ${deleteObj.userName}?`}
            showCloseButton={false}
        />
        <AddEditUserWithoutEHandelAccessModal
            show={addEditObj.show}
            onHide={() => setAddEditObj({ show: false, user: null })}
            user={addEditObj.user}
            handleDownloadUsers={handleDownloadUsers}
        />
        <SelectUserRolesModal
            show={showSelectUserRolesModal}
            onHide={handleAddEhandelUser}
        />
        <YesNoCancelMessageModal
            show={showCrmPickTypeModal}
            onHide={handleCrmTypeModalAnswer}
            title={'Rodzaj zdarzenia'}
            message={'Wybierz rodzaj zdarzenia'}
            yesText="Telefon"
            noText="Wizyta"
            cancelText="Dowolne zdarzenie CRM"
            showCloseButton={true}
        />
        <AddEditCrmTaskModal
            show={crmModalObj.show}
            onHide={() => setCrmModalObj({ show: false, type: '', userName: '' })}
            type={crmModalObj.type}
            userName={crmModalObj.userName}
        />

        <div className='row justify-content-center'>
            <div className='col-12 col-xxl-8 mt-2 '>
                <div className='main-container-holder'>
                    <div className="d-flex justify-content-between align-items-center">
                        <span className='panel-header-title'>Kontakty</span>
                        <div className="d-flex">
                            <span>Tylko niezarejestrowani w eHandlu</span>
                            <div className={`custom-switch ms-2 ${showOnlyUsersWithoutEHandelAccess ? 'active' : ''}`} onClick={() => setShowOnlyUsersWithoutEHandelAccess(prev => !prev)}>
                                <div className="custom-switch-circle"></div>
                            </div>
                        </div>
                    </div>
                    <div className='table-responsive mt-3'>
                        <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                            <thead>
                                <tr>
                                    <th style={{ width: '2%', textAlign: 'center', paddingInline: 5 }}>LP</th>
                                    <th style={{ width: '20%' }}>IMIĘ <br /> NAZWISKO</th>
                                    <th style={{ width: '26%' }}>ADRES E-MAIL</th>
                                    <th style={{ width: '15%' }}>NUMER KONTAKTOWY</th>
                                    <th style={{ width: '22%' }}>STANOWISKO</th>
                                    <th style={{ width: '2%' }}>
                                        <span>ODBIÓR</span>
                                        <br />
                                        <span>FV</span>
                                    </th>
                                    <th style={{ width: '2%' }}>
                                        <span>ODBIÓR</span>
                                        <br />
                                        <span>TOWARÓW</span>
                                    </th>
                                    <th style={{ width: '2%', textAlign: 'center' }}></th>
                                    <th style={{ width: '2%', textAlign: 'center' }}></th>
                                    <th style={{ width: '2%', textAlign: 'center' }}></th>
                                    <th style={{ width: '2%', textAlign: 'center' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                <TableBody
                                    users={showOnlyUsersWithoutEHandelAccess ? users?.filter(u => !u.isEHandel) : users}
                                    handleDeleteClick={handleDeleteClick}
                                    isLoading={isLoading}
                                    setAddEditObj={setAddEditObj}
                                    setUserToAddAccesstoEhandel={setUserToAddAccesstoEhandel}
                                    setShowSelectUserRolesModal={setShowSelectUserRolesModal}
                                    authState={authState}
                                    setShowCrmPickTypeModal={setShowCrmPickTypeModal}
                                    setCrmModalObj={setCrmModalObj}
                                />
                            </tbody>
                        </table>
                        {isLoading && <LoadingSpinner />}
                    </div>

                    <button className='btn-app-secondary mt-3' onClick={() => {
                        if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 2) {
                            toast.warning('Brak uprawnień!')
                            return
                        }
                        setAddEditObj({ show: true, user: null })
                    }}>Dodaj użytkownika</button>
                </div>
            </div>
        </div>
    </>)
}

const TableBody = ({ users, handleDeleteClick, isLoading, setAddEditObj, setUserToAddAccesstoEhandel, setShowSelectUserRolesModal, authState, setShowCrmPickTypeModal,
    setCrmModalObj
}) => {
    const { getInfoCheckbox } = useCommonFunctions()

    const popover = (text) => <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{text}</span>
        </Popover.Body>
    </Popover>

    const handleGetEHandelAccess = (user) => {
        if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 2) {
            toast.warning('Brak uprawnień!')
            return
        }
        setUserToAddAccesstoEhandel(user)
        setShowSelectUserRolesModal(true)
    }

    if (isLoading) {
        return null
    }
    if (users && users.length > 0) {
        return users.map((user, index) => {
            return (<tr className='hoverable-row'>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td>
                    <span>{user.name}</span>
                    <br />
                    <span>{user.surname}</span>
                </td>
                <td>{user.email}</td>
                <td>{formatPhoneNumber(user.phoneNumber)}</td>
                <td>{user.position}</td>
                <td>{getInfoCheckbox(user.isInvoiceCollector)}</td>
                <td>{getInfoCheckbox(user.isAssortCollector)}</td>
                <td className="element-pointer">
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Edytuj')}>
                        <div>
                            <FaRegEdit onClick={() => setAddEditObj({ show: true, user: user })} />
                        </div>
                    </OverlayTrigger>
                </td>
                <td className="element-pointer">
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover(user.isEHandel ? 'Zarejestrowany w eHandlu' : 'Przyznaj dostęp do e-Handlu')}>
                        <div>
                            {user.isEHandel ? (<FaCheck color="var(--success-color)" />) : (<IoMdAddCircleOutline onClick={() => handleGetEHandelAccess(user)} />)}
                        </div>
                    </OverlayTrigger>
                </td>
                <td className="element-pointer">
                    {!user.isEHandel && <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Usuń kontakt')}>
                        <div>
                            <RxCross2 color="var(--error-color)" onClick={() =>
                                handleDeleteClick(user.recNo, `${user.name} ${user.surname}`, user.custId, user.contactNumber, authState.user.kod, authState.user.userLogin)}
                            />
                        </div>
                    </OverlayTrigger>}
                </td>
                <td className="element-pointer">
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Zdarzenia CRM')}>
                        <div>
                            <MdNoteAdd onClick={() => {
                                if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 2) {
                                    toast.warning('Brak uprawnień!')
                                    return
                                }
                                setCrmModalObj(prev => ({
                                    ...prev,
                                    userName: `${user.name} ${user.surname}`
                                }))
                                setShowCrmPickTypeModal(true)
                            }} />
                        </div>
                    </OverlayTrigger>
                </td>
            </tr>)
        })
    }
}

export default CustomersWithoutEHandelAccess